import { AnalyticsDenialError, analyticsErrorCopy } from "./analyticsClient.js";
import { getMyPermissions } from "./permissions.js";

// Preserve the typed analytics denial until this final user/model-facing
// boundary. Matching raw strings here would make it easy for an earlier
// `.message` conversion to re-introduce the backend's 403 body.
export function kernelErrorMessage(error, caps, fallback = "kernel failed") {
    if (error instanceof AnalyticsDenialError) {
        return analyticsErrorCopy(error, caps).message;
    }
    if (error?.message) return error.message;
    if (error != null) {
        const message = String(error);
        if (message) return message;
    }
    return fallback;
}

// Non-React kernel callers (editor/test/workflow tools) still need the
// viewer's role posture for explanatory denial copy. Avoid the permissions
// fetch for ordinary failures so their existing error paths stay unchanged.
export async function kernelErrorMessageForCurrentUser(error, fallback = "kernel failed") {
    if (!(error instanceof AnalyticsDenialError)) {
        return kernelErrorMessage(error, null, fallback);
    }
    const caps = await getMyPermissions();
    return kernelErrorMessage(error, caps, fallback);
}
